import {
  enUS,
  de,
  fr,
  it,
  fi,
  pl,
  bg,
  cs,
  da,
  es,
  ru,
  et,
  pt,
  ro,
  sk,
  tr,
  vi,
  type Locale,
} from "date-fns/locale";

export const dateFnsLocales = {
  en: enUS,
  de,
  fr,
  it,
  fi,
  pl,
  bg,
  cs,
  da,
  es,
  ru,
  et,
  pt,
  ro,
  sk,
  tr,
  vi,
} as Record<string, Locale>;
